export const OPEN_PROJECT_SURFACE = 'holzcom:open-project-surface';

export type ProjectSurface = 'menu' | 'diagnostics';

export function openProjectSurface(surface: ProjectSurface): void {
  const event = new CustomEvent(OPEN_PROJECT_SURFACE, { cancelable: true, detail: surface });
  window.dispatchEvent(event);
  if (!event.defaultPrevented) throw new Error('PROJECT_SURFACE_OWNER_UNAVAILABLE');
}
